module.exports = __webpack_public_path__ + "a43783c23c2be578e2384243e0825994.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MW.svg
// module id = utL6
// module chunks = 0